/* recharge-bundle-overrides.js — v6-lite */
(function () {
  const root = document.getElementById('bundling-app') || document;
  let scheduled = false;

  function applyPatches() {
    scheduled = false;
    try {
      /* A) Prices: hide .00/. ,00 and keep original price hidden */
      document.querySelectorAll('.rb-price').forEach(p => {
        // hide struck-through original/full price
        const strike = p.querySelector('.tstrike');
        if (strike) strike.style.setProperty('display', 'none', 'important');
        const full = p.querySelector('.rb-full-price');
        if (full) full.style.setProperty('display', 'none', 'important');

        // remove .00 or ,00 in text nodes
        p.childNodes.forEach(n => {
          if (n.nodeType === 3) {
            n.nodeValue = n.nodeValue.replace(/(\$?\s*\d+)([.,]00)\b/g, '$1');
          }
        });
        // also clean any nested text
        p.querySelectorAll('*').forEach(el => {
          el.childNodes.forEach(n => {
            if (n.nodeType === 3) {
              n.nodeValue = n.nodeValue.replace(/(\$?\s*\d+)([.,]00)\b/g, '$1');
            }
          });
        });
      });

      /* B) Frequency options: remove "Delivery/Delivered", uppercase */
      const sel = document.getElementById('selling-plan-list');
      if (sel && sel.options) {
        Array.from(sel.options).forEach(opt => {
          const raw = (opt.textContent || opt.label || '').trim();
          if (!raw) return;
          let cleaned = raw.replace(/^\s*(delivered?|delivery)\s+/i, '').replace(/\s+/g, ' ').trim();
          cleaned = cleaned.toUpperCase();
          if (opt.textContent !== cleaned) opt.textContent = cleaned;
          try { opt.label = cleaned; } catch (_) {}
        });
      }
    } catch (_) {}
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(applyPatches);
    setTimeout(applyPatches, 60);
  }

  // initial + watch for widget re-renders (no attribute watching to avoid loops)
  schedule();
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
})();

